import axios from 'axios';
import qs from 'qs';
import notification from 'ant-design-vue/es/notification'

const TOKEN_KEY = 'admin.token';

const request = axios.create({
    // 开发走同源 /api，由 vue.config.js devServer 代理，避免跨域
    // 打包后仍直连线上 API
    baseURL: process.env.NODE_ENV === 'development'
        ? '/api/'
        : 'https://adminapi.pc28sz.com/',

    //baseURL: 'http://adminapi.michong.com',
    timeout: 30000,
});

function requestGet(url, params) {
    if (params && Object.keys(params).length !== 0) {
        url += '?' + qs.stringify(params);
    }
    console.log('url:' + url);
    return request({
        url: url,
        method: 'GET'
    });
}

function requestPost(url, params) {
    console.log('url:' + url);
    params = params && qs.stringify(params);
    return request({
        url: url,
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    });
}

function requestUpload(url, form) {
    return request({
        url: url,
        method: 'POST',
        headers: {},
        params:{},
        data: form
    });
}

// 错误处理
const errorHandler = (error) => {
    if (error.response) {
        if (error.response.status === 403) {
            notification.error({
                message: '权限不足',
                description: '你没有该权限'
            });
        } else if(error.response.status === 404) {
            notification.error({
                message: '404',
                description: '资源不存在'
            });
        } else if(error.response.status === 401) {
            const token = getToken();
            notification.error({
                message: '未登录',
                description: '你还没有登录，或登录已过期'
            });

            if(token) {
                removeToken();
                setTimeout(() => {
                    window.location.reload();
                });
            }
        } else if(error.response.status === 500) {
            console.error(error.response.data);
        }
    }
    return Promise.reject(error);
}

// 请求拦截器
request.interceptors.request.use(config => {
    const token = getToken();
    if(token) {
        config.headers['token'] = token;
    }
    return config;
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response) => {
    let res = response.data;
    res.isSucceed = (res.code == '200') ? true : false;
    return res;
}, errorHandler);

function getToken() {
    return window.sessionStorage.getItem(TOKEN_KEY) || '';
}

function setToken(token) {
    window.sessionStorage.setItem(TOKEN_KEY, token);
    window.localStorage.removeItem(TOKEN_KEY);
}

function checkToken() {
    return !!getToken();
}

function removeToken() {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem('admin.adminInfo');
    window.sessionStorage.removeItem('admin.permissions');
    window.sessionStorage.removeItem('admin.menus');
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem('admin.adminInfo');
    window.localStorage.removeItem('admin.permissions');
    window.localStorage.removeItem('admin.menus');
}

export {
    request,
    requestGet,
    requestPost,
    requestUpload,
    getToken,
    setToken,
    checkToken,
    removeToken
}
